import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { Flex } from 'foundations-components/components/Flex';
import { Link } from 'foundations-components/transitional/components/Link';
import { List, ListItem } from 'foundations-components/transitional/components/List';
import { getFullUrl } from 'hubspot-url-utils';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useState } from 'react';
import { Button } from 'foundations-components/transitional/components/Button';
import I18n from 'I18n';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const FaceNavPortalPickerSubmenu = ({
  accounts,
  onMouseEnter,
  onMouseLeave
}) => {
  const [hoveredAccountId, setHoveredAccountId] = useState(null);
  return /*#__PURE__*/_jsxs(View, {
    "aria-label": I18n.text('learningCenter.faceNav.accessibility.portal_picker'),
    id: "face-nav-portal-picker-menu",
    maxBlockSize: "235px",
    maxInlineSize: "350px",
    onMouseEnter: onMouseEnter,
    onMouseLeave: onMouseLeave,
    overflowX: "hidden",
    overflowY: "scroll",
    role: "menu",
    children: [/*#__PURE__*/_jsx(View, {
      borderBlockEndStyle: "solid",
      borderBlockEndWidth: "100",
      borderColor: "border-core-default",
      padding: "400",
      children: /*#__PURE__*/_jsx(Link, {
        href: `${getFullUrl('app')}/myaccounts-beta`,
        children: /*#__PURE__*/_jsx(Text, {
          color: "text-interactive-default",
          typography: "heading-50",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "learningCenter.faceNav.accounts"
          })
        })
      })
    }), /*#__PURE__*/_jsx(List, {
      children: accounts.map(account => /*#__PURE__*/_jsx(ListItem, {
        children: /*#__PURE__*/_jsx(View, {
          backgroundColor: hoveredAccountId === account.id ? 'fill-field-hover' : 'fill-surface-default',
          children: /*#__PURE__*/_jsx(Button, {
            block: true,
            onClick: () => {
              window.open(`${account.appDomain}/home-beta?portalId=${account.id}`);
            },
            onMouseEnter: () => setHoveredAccountId(account.id),
            onMouseLeave: () => setHoveredAccountId(null),
            use: "unstyled",
            children: /*#__PURE__*/_jsxs(Flex, {
              alignItems: "center",
              flex: "1",
              flexDirection: "row",
              gap: "100",
              justifyContent: "start",
              maxInlineSize: "100%",
              minInlineSize: "0",
              paddingBlock: "200",
              paddingInline: "400",
              children: [/*#__PURE__*/_jsxs(Text, {
                typography: "heading-50",
                whiteSpace: "nowrap",
                children: [account.accountName, ":"]
              }), /*#__PURE__*/_jsx(Text, {
                children: account.id
              })]
            })
          })
        })
      }, account.id))
    })]
  });
};